var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-card',[_c('v-card-title',[_c('v-spacer')],1),_c('v-card',[_c('iframe',{attrs:{"src":_vm.iframeUrl,"frameborder":"0","width":"100%","height":"1000","allowtransparency":""}})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }